module.exports = __webpack_public_path__ + "static/media/close-4.60354da3.svg";